export default __webpack_public_path__ + "static/nextjs-5fd3e56fd8fc9899491e96afa340ac60.svg";